/** The legend sheet pages' paths. The plant is in every one so a reload and a shared
 *  link open the same plant: a query parameter on the list, a segment elsewhere. */

export function legendSheetListRoute(domainId: string) {
  return `/legend-sheets?domain_id=${encodeURIComponent(domainId)}`;
}

export function legendSheetRecordRoute(domainId: string, sheetId: string) {
  return `/legend-sheets/${encodeURIComponent(domainId)}/${encodeURIComponent(sheetId)}`;
}

export function newLegendSheetRoute(domainId: string) {
  return `/legend-sheets/${encodeURIComponent(domainId)}/new`;
}
